export default function Technology() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/1b88de63384c1bcce3927af60b8cb4da.jpg"
                alt="循環型陸上養殖システム"
                className="w-full h-[500px] object-cover"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
              <i className="ri-microscope-line text-[#2D7A3E] text-lg mr-2"></i>
              <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">先進技術</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
              筑波大学との<br />
              共同研究技術
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              筑波大学生命環境系 名誉教授 張振亜教授が開発した閉鎖循環型陸上養殖システム。環境負荷を最小限に抑えながら、高品質な水産物を安定生産します。
            </p>

            <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-6 rounded-xl border border-[#E8F5E9] mb-6">
              <h4 className="font-semibold text-[#1A2332] mb-3 flex items-center">
                <i className="ri-water-flash-line text-[#2D7A3E] text-xl mr-2"></i>
                閉鎖循環型システムの特徴
              </h4>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <span className="text-[#2D7A3E] mr-2">•</span>
                  <span>水の使用量を従来の1/10以下に削減</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#2D7A3E] mr-2">•</span>
                  <span>排水による環境汚染をゼロに</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#2D7A3E] mr-2">•</span>
                  <span>天候に左右されない安定生産</span>
                </li>
                <li className="flex items-start">
                  <span className="text-[#2D7A3E] mr-2">•</span>
                  <span>病気のリスクを大幅に低減</span>
                </li>
              </ul>
            </div>

            <div className="flex items-center space-x-4">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#2D7A3E] rounded-full flex items-center justify-center mr-3">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600">技術顧問</p>
                  <p className="font-semibold text-[#1A2332]">張振亜 名誉教授</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}